import { PermissionT } from "../types";

export const roofDesignAdmin = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "roof_design_admin");
  return !!p;
};

export default roofDesignAdmin;
